/**
 * ivyClientParser.ts — Phase 3
 *
 * Frontend-side utility to strip the ---INTENT--- block from Ivy response
 * content before rendering or storing in conversation history.
 *
 * Mirrors the server-side stripIntentBlock from server/src/ivy/intentParser.ts.
 * Kept as a separate frontend file so the frontend bundle never imports server
 * code.
 */

const INTENT_BLOCK_RE = /---INTENT---\s*([\s\S]*?)\s*---END INTENT---/

export function stripIntentBlock(content: string): string {
  return content.replace(INTENT_BLOCK_RE, '').replace(/\n{3,}/g, '\n\n').trim()
}
